/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentAuthorization.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Authorization API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 5:05 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const Authorization = {
    current: () =>
        requests.get('/user'),
    login: (username, password) =>
        requests.post('/login', { username, password }),
    register: (firstname, lastname, username, email, password) =>
        requests.post('/Registration', { firstname, lastname, username, email, password }),
    save: user =>
        requests.put('/user', { user }),
    checkusername: (username) =>
        requests.post('/CheckUsername', { username }),
    checkemail: (email) =>
        requests.post('/CheckEmail', { email }),
    sendusername: (email) =>
        requests.post('/SendUsername', { email }),
    resetpassword: (email) =>
        requests.post('/SendResetPassword', { email })
};

export const Roles = {
    all: () => requests.get('/Roles'),
    get: roleid => requests.get(`/Role/${roleid}`),
    create: role => requests.post(`/Roles`, role),
    update: (roleid, role) => requests.put(`/Role/${roleid}`, role),
    delete: roleid => requests.del(`/Role/${roleid}`),
};
